import debounce from 'lodash.debounce'
import { Schema } from 'yup'

import { ValidationResponseTypes } from 'shared/ui/form/inputs'

export const validateField = (schema: Schema<unknown>, values: unknown) => {
  return async (
    name: string,
    callback: (v: ValidationResponseTypes) => void
  ) => {
    try {
      await schema.validateAt(name, values)
      callback?.({ valid: true, message: '' })
    } catch (e) {
      callback?.({ valid: false, message: (e as Error).message || '' })
    }
  }
}

type ValidationError = { path: string; message: string }

export const validateValues = (schema: Schema<unknown>) =>
  debounce(
    (
      values: unknown,
      callback: (valid: boolean, errors: Record<string, string>) => void
    ) => {
      schema
        .validate(values, { abortEarly: false })
        .then(() => callback(true, {}))
        .catch((err: { inner: ValidationError[] }) => {
          const errors = err.inner.reduce(
            (acc: Record<string, string>, error: ValidationError) => {
              acc[error.path] = error.message

              return acc
            },
            {}
          )

          callback(false, errors)
        })
    },
    400
  )

export const isEmailValid = (email: string) => {
  const emailRegex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/

  return emailRegex.test(email)
}

const preventedNumberInputKeys = ['-', 'e', '+']

interface ShouldPreventKeyForNumberInputProps {
  key: string
  type?: string
  additionalBlockedKeys?: string[]
}

export const shouldPreventKeyForNumberInput = ({
  type,
  key,
  additionalBlockedKeys = []
}: ShouldPreventKeyForNumberInputProps): boolean => {
  return (
    type === 'number' &&
    new Set([...preventedNumberInputKeys, ...additionalBlockedKeys]).has(key)
  )
}
